/* global HSLoadingState */

import React, { useContext, useEffect, useState, useRef } from "react";
import LanguageContext from "../../utils/Contexts/LanguageContext";
import axiosInstance from "../../utils/Requests/axios";
import TablePagination from "../Common/Pagination";
import _ from "lodash";
import toast from "react-hot-toast";
import Footer from "../Footer";
import DomainRating from "./DomainRating";
import CardTable from "./CardTable";
import { useParams } from "react-router-dom";
import { useLoading } from "../../utils/Contexts/LoadingContext";
import { useNavigate } from "react-router-dom";
import PlacementFilterModal from "../../modals/PlacementFilterModal";
import FilterIcon from "../svg/FilterIcon";

import "./style.css"

function Placement() {
  const { isLoading, setIsLoading } = useLoading();
  const { t } = useContext(LanguageContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const [optionsDomain, setOptionsDomain] = useState([]);
  const [domainData, setDomainData] = useState([]);
  const [domainRating, setDomainRating] = useState({});
  const [activePlacementTab, setActivePlacementTab] = useState(null);
  const [activeRelTab, setActiveRelTab] = useState(null);
  const [activeLinkTab, setActiveLinkTab] = useState(null);
  const [activeNicheTab, setActiveNicheTab] = useState(null);
  const [recordsFiltered, setRecordsFiltered] = useState(0);
  const [pageCount, setPageCount] = useState(15);
  const [activePage, setActivePage] = useState(1);
  const [columnSorts, setColumnSorts] = useState({
    0: null,
    1: null,
    2: null,
    3: null,
    4: null,
    5: null,
    6: null,
    7: null,
    8: null,
  });
  const [formData, setFormData] = useState({
    draw: 1,
    columns: [
      { data: "money_back" },
      { data: "link_replacement" },
      { data: "tat" },
      { data: "links" },
      { data: "acceptance_rate" },
      { data: "links_alive" },
    ],
    order: [],
    start: 0,
    length: 15,
    search: {
      value: "",
      filters: [
        {
          key: "UUID",
          value: id,
        },
      ],
    },
  });

  const domainHistoryCalled = useRef(false);
  const getDomainRatingData = () => {
    if (domainHistoryCalled.current) return;
    domainHistoryCalled.current = true;
    const url = `/domains/${id}/history`;
    setIsLoading(true);
    axiosInstance
      .get(url)
      .then((response) => {
        setDomainRating(response?.data);
        setIsLoading(false);
      })
      .catch(() => {
        toast.error(t("There was an error fetching domain history"));
      });
  };

  const allPlacements = [
    { value: 1, name: t("Guest Post") },
    { value: 2, name: t("Link Insert") },
    { value: 3, name: t("Niche Edit") },
  ];
  const allRels = [
    { value: 1, name: t("Do Follow") },
    { value: 2, name: t("No Follow") },
    { value: 3, name: t("Sponsored") },
  ];
  const allLinks = [
    { value: 1, name: "1" },
    { value: 2, name: "2" },
    { value: 3, name: "3" },
  ];
  const niches = [
    {
      value: 1,
      title: "General",
      content: <i className="bi-file-earmark-richtext"></i>,
    },
    {
      value: 2,
      title: "Gambling",
      content: <i className="bi bi-dice-5"></i>,
    },
    {
      value: 3,
      title: "Crypto",
      content: <i className="bi bi-currency-bitcoin"></i>,
    },
    {
      value: 4,
      title: "Medications",
      content: <i className="bi bi-capsule"></i>,
    },
    {
      value: 5,
      title: "Dating",
      content: <i className="bi bi-chat-left-heart"></i>,
    },
    {
      value: 6,
      title: "Adult",
      content: <span style={{ fontSize: "9px" }}>18+</span>,
    },
  ];

  const offersSummaryCalled = useRef(false);
  const getOptionsData = () => {
    if (offersSummaryCalled.current) return;
    offersSummaryCalled.current = true;
    const url = `/domains/${id}/offers-summary`;
    setIsLoading(true);
    axiosInstance
      .get(url)
      .then((response) => {
        setOptionsDomain(response?.data?.summary);
        if (
          response?.data?.summary?.rels &&
          response?.data?.summary?.rels.length > 0
        ) {
          handleRelTabClick(response?.data?.summary?.rels[0]);
        }
        if (
          response?.data?.summary?.links &&
          response?.data?.summary?.links.length > 0
        ) {
          handleLinkClick(response?.data?.summary?.links[0]);
        }
        if (
          response?.data?.summary?.placements &&
          response?.data?.summary?.placements.length > 0
        ) {
          handlePlacementTabClick(response?.data?.summary?.placements[0].type);
        }
        if (
          response?.data?.summary?.niches &&
          response?.data?.summary?.niches.length > 0
        ) {
          handleNicheClick(response?.data?.summary?.niches[0]);
        }
        setIsLoading(false);
      })
      .catch(() => {
        toast.error(t("There was an error fetching filters"));
      });
  };

  useEffect(() => {
    getOptionsData();
    getDomainRatingData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const placements = optionsDomain.placements || [];
  const rels = optionsDomain.rels || [];
  const links = optionsDomain.links || [];
  const allNiches = optionsDomain.niches || [];

  const handlePlacementTabClick = (placementValue) => {
    setActivePlacementTab(placementValue);
    updateFilter("TYPE", placementValue);
  };

  const handleRelTabClick = (relValue) => {
    setActiveRelTab(relValue);
    updateFilter("REL", relValue);
  };

  const handleLinkClick = (linkValue) => {
    setActiveLinkTab(linkValue);
    updateFilter("LINKS", linkValue);
  };

  const handleNicheClick = (NicheValue) => {
    setActiveNicheTab(NicheValue);
    updateFilter("NICHE", NicheValue);
  };

  const fetchSingleDomainsData = () => {
    const payload = _.cloneDeep(formData);

    const url = `/domain-offers-search`;
    setIsLoading(true);
    axiosInstance
      .post(url, payload)
      .then((response) => {
        const data = response?.data?.data || [];
        const filtered = response?.data?.recordsFiltered || 0;
        setDomainData(data);
        setRecordsFiltered(filtered);
        setIsLoading(false);
      })
      .catch(() => {
        toast.error(t("There was an error fetching domain data"));
      });
  };

  useEffect(() => {
    if (activeRelTab && activePlacementTab && activeLinkTab && activeNicheTab) {
      fetchSingleDomainsData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  useEffect(() => {
    const payload = { ...formData };
    const order = [];
    Object.keys(columnSorts).forEach((columnIndex) => {
      if (columnSorts[columnIndex]) {
        order.push({
          column: columnIndex,
          dir: columnSorts[columnIndex],
        });
      }
    });
    if (order.length) {
      payload.order = order;
      setFormData(payload);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnSorts]);

  useEffect(() => {
    const payload = { ...formData };
    const start = activePage === 1 ? 0 : (activePage - 1) * pageCount;
    if (payload.start !== start || payload.length !== pageCount) {
      payload.start = start;
      payload.length = pageCount;
      setFormData(payload);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePage, pageCount]);

  const updateFilter = (key, value) => {
    setFormData((prevData) => {
      const updatedFilters = prevData.search.filters.filter(
        (filter) => filter.key !== key
      );

      return {
        ...prevData,
        length:15,
        search: {
          ...prevData.search,
          filters: [...updatedFilters, { key: key, value: value }],
        },
      };
    });
  };

  const hsInitRef = useRef(null);
  useEffect(() => {
    if (!hsInitRef.current) {
      new HSLoadingState(".js-loading-state-invoker");
      // eslint-disable-next-line react-hooks/exhaustive-deps
      hsInitRef.current = true;
    }
  }, []);

  // for smaller screen pre set filters to be called on apply
  const [pendingFilters, setPendingFilters] = useState([]);

  const updatePendingFilter = (key, value) => {
    setPendingFilters((prevFilters) => {
      const updatedFilters = prevFilters.map((filter) =>
        filter.key === key ? { key, value } : filter
      );

      const finalFilters = updatedFilters.some((filter) => filter.key === key)
        ? updatedFilters
        : [...updatedFilters, { key, value }];

      return finalFilters;
    });
  };

  return (
    <main id="content" role="main" className="main">
      <div className="content container-fluid">
        <div className="page-header">
          <div className="row align-items-end">
            <div className="col-sm mb-2 mb-sm-0">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb breadcrumb-no-gutter">
                  <li className="breadcrumb-item">
                    {/* eslint-disable-next-line */}
                    <a href="javascript:;"
                      className="breadcrumb-link"
                      onClick={() => navigate("/offers-search")}
                    >
                      {t("Backlinks")}
                    </a>
                  </li>
                  <li className="breadcrumb-item">
                    <a className="breadcrumb-link" href="/offers-search">
                      {t("Backlinks Offers Search")}
                    </a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {t("Placement Options")}
                  </li>
                </ol>
              </nav>

              <h1 className="page-header-title">
                <span>
                  {domainRating?.domain}{" "}
                  <i
                    className="bi-patch-check-fill text-primary"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Top endorsed"
                  ></i>
                </span>
              </h1>
            </div>
          </div>
        </div>
        <div className="mb-3 mb-lg-5">
          <DomainRating domainRating={domainRating} flag={false} />
        </div>
        <div className="card">
          <div className="card-header d-flex justify-content-between">
            <div className="d-flex gap-2 flex-wrap">
              <div className="d-md-block d-none js-nav-scroller hs-nav-scroller-horizontal">
                <div className="text-sm-center">
                  <ul
                    className="nav nav-segment flex-wrap flex-sm-nowrap"
                    role="tablist"
                  >
                    <li className="nav-item">
                      <span className="nav-link">{t("Placement")}</span>
                    </li>
                    {allPlacements.map((placement) => {
                      const isAvailable = placements.some(
                        (p) => p.type === placement.value
                      );
                      return (
                        <li className="nav-item" key={placement.value}>
                          <a
                            className={`js-loading-state-invoker nav-link ${
                              activePlacementTab === placement.value
                                ? "active"
                                : ""
                            } ${!isAvailable || isLoading ? "disabled" : ""}`}
                            id="nav-one-eg1-tab"
                            data-bs-toggle="pill"
                            href="#nav-one-eg1"
                            role="tab"
                            aria-controls="nav-one-eg1"
                            aria-selected={
                              activePlacementTab === placement.value
                            }
                            onClick={(e) => {
                              if (!isAvailable || isLoading) {
                                e.preventDefault();
                                return;
                              }
                              handlePlacementTabClick(placement.value);
                            }}
                            data-hs-loading-state-options='{
                              "targetEl": "#nav-one-eg1",
                              "removeLoaderDelay": "300"
                            }'
                          >
                            {placement.name}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>

              <div className="d-md-block d-none">
                <div className="text-sm-center">
                  <ul
                    className="nav nav-segment flex-wrap flex-sm-nowrap"
                    role="tablist"
                  >
                    <li className="nav-item">
                      <span className="nav-link">{t("Links")}</span>
                    </li>
                    {allLinks.map((link) => {
                      const isAvailable = links.includes(link.value);
                      return (
                        <li className="nav-item" key={link.value}>
                          <a
                            className={`js-loading-state-invoker nav-link ${
                              activeLinkTab === link.value ? "active" : ""
                            } ${!isAvailable || isLoading ? "disabled" : ""}`}
                            id="nav-one-eg1-tab"
                            data-bs-toggle="pill"
                            href="#nav-one-eg1"
                            role="tab"
                            aria-controls="nav-one-eg1"
                            aria-selected={activeLinkTab === link.value}
                            onClick={(e) => {
                              if (!isAvailable || isLoading) {
                                e.preventDefault();
                                return;
                              }
                              handleLinkClick(link.value);
                            }}
                            data-hs-loading-state-options='{
                              "targetEl": "#nav-one-eg1",
                              "removeLoaderDelay": "300"
                            }'
                          >
                            {link.name}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>

              <div className="d-xxl-block d-none">
                <div className="text-sm-center">
                  <ul
                    className="nav nav-segment flex-wrap flex-sm-nowrap"
                    role="tablist"
                  >
                    <li className="nav-item">
                      <span className="nav-link">{t("Rel Type")}</span>
                    </li>
                    {allRels.map((rel) => {
                      const isAvailable = rels.includes(rel.value);
                      return (
                        <li className="nav-item" key={rel.value}>
                          <a
                            className={`js-loading-state-invoker nav-link ${
                              activeRelTab === rel.value ? "active" : ""
                            } ${!isAvailable || isLoading ? "disabled" : ""}`}
                            id="nav-one-eg1-tab"
                            data-bs-toggle="pill"
                            href="#nav-one-eg1"
                            role="tab"
                            aria-controls="nav-one-eg1"
                            aria-selected={activeRelTab === rel.value}
                            onClick={(e) => {
                              if (!isAvailable || isLoading) {
                                e.preventDefault();
                                return;
                              }
                              handleRelTabClick(rel.value);
                            }}
                            data-hs-loading-state-options='{
                              "targetEl": "#nav-one-eg1",
                              "removeLoaderDelay": "300"
                            }'
                          >
                            {rel.name}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>

              <div className="d-xxl-block d-none">
                <div className="text-sm-center">
                  <ul
                    className="nav nav-segment flex-wrap flex-sm-nowrap"
                    role="tablist"
                  >
                    <li className="nav-item">
                      <span className="nav-link">{t("Niche")}</span>
                    </li>
                    {niches.map((nicheValue) => {
                      const matchingNiche = allNiches.includes(
                        nicheValue.value
                      );
                      return (
                        <li className="nav-item" key={nicheValue.value}>
                          <a
                            className={`js-loading-state-invoker nav-link ${
                              activeNicheTab === nicheValue.value
                                ? "active"
                                : ""
                            }${!matchingNiche || isLoading ? "disabled" : ""}`}
                            id="nav-tree-eg1-tab"
                            data-bs-toggle="pill"
                            href="#nav-one-eg1"
                            role="tab"
                            aria-controls="nav-one-eg1"
                            aria-selected="false"
                            data-hs-loading-state-options='{
                              "targetEl": "#nav-one-eg1",
                              "removeLoaderDelay": "300"
                            }'
                            onClick={(e) => {
                              if (!matchingNiche || isLoading) {
                                e.preventDefault();
                                return;
                              }
                              handleNicheClick(nicheValue.value);
                            }}
                          >
                            <span className="avatar avatar-xs avatar-secondary avatar-circle">
                              <span
                                className="avatar-initials"
                                style={
                                  !matchingNiche
                                    ? {
                                        backgroundColor:
                                          "rgba(143, 149, 156, .3)",
                                      }
                                    : {}
                                }
                              >
                                {nicheValue.content}
                              </span>
                            </span>
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
            <div className="d-xxl-none d-block">
              <div className="btn-group dropupend ms-auto">
                <button
                  className="btn btn-white text-nowrap"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasPlacementFilter"
                  aria-controls="offcanvasPlacementFilter"
                >
                  <FilterIcon />{" "}
                  <span className="ps-1 align-middle">
                    {t("Filters")}
                    {pendingFilters?.length > 0 &&
                      `(${pendingFilters?.length})`}
                  </span>{" "}
                </button>
              </div>
            </div>
          </div>

          <CardTable
            setColumnSorts={setColumnSorts}
            columnSorts={columnSorts}
            domainData={domainData}
          />

          <TablePagination
            activePage={activePage}
            setActivePage={setActivePage}
            recordsFiltered={recordsFiltered}
            setPageCount={setPageCount}
            pageCount={pageCount}
          />
        </div>
      </div>
      <Footer />
      <PlacementFilterModal
        allPlacements={allPlacements}
        allLinks={allLinks}
        allRels={allRels}
        rels={rels}
        links={links}
        placements={placements}
        activePlacementTab={activePlacementTab}
        activeRelTab={activeRelTab}
        activeLinkTab={activeLinkTab}
        isLoading={isLoading}
        niches={niches}
        allNiches={allNiches}
        activeNicheTab={activeNicheTab}
        setFormData={setFormData}
        setActivePlacementTab={setActivePlacementTab}
        setActiveRelTab={setActiveRelTab}
        setActiveLinkTab={setActiveLinkTab}
        setActiveNicheTab={setActiveNicheTab}
        updatePendingFilter={updatePendingFilter}
        pendingFilters={pendingFilters}
      />
    </main>
  );
}

export default Placement;
